import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiTimeRangeComponent } from './multi-time-range.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';


@NgModule({
    declarations: [MultiTimeRangeComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NzToolTipModule,
        NzIconModule,
        NzButtonModule
    ],
    exports: [MultiTimeRangeComponent]
})
export class MultiTimeRangeModule {
}
